import { ReactNode } from 'react';
import { defineMessage } from 'react-intl';
import styled from 'styled-components';

import { Vertical } from 'atoms/layout/flex';
import { BrandS, BrandXXS } from 'atoms/typography';
import { Ordinal } from 'atoms/typography/Ordinal';
import { Chip } from 'atoms/ui/Chip';

const Root = styled(Vertical)`
  height: 100%;
`;
const ChipWrapper = styled.div`
  padding: 2px var(--unit);
`;

const LowercaseBrandXXS = styled(BrandXXS).attrs({ as: 'sup' })`
  text-transform: lowercase;
`;

const ChildrenWrapper = styled.div`
  height: 100%;
  & > * {
    height: 100%;
  }
`;

const stepMessage = defineMessage({
  id: 'StepsNumber',
  defaultMessage:
    '{ordinal, selectordinal, one {#<sup>st</sup>} two {#<sup>nd</sup>} few {#<sup>rd</sup>} other {#<sup>th</sup>}} step',
});

export const Season26TutorialStep = ({
  stepNb,
  children,
}: {
  stepNb: number;
  children: ReactNode;
}) => {
  return (
    <Root>
      <ChipWrapper>
        <Chip color="transparent">
          <BrandS uppercase>
            <Ordinal
              i18n={stepMessage}
              ordinal={stepNb}
              Sup={LowercaseBrandXXS}
            />
          </BrandS>
        </Chip>
      </ChipWrapper>
      <ChildrenWrapper>{children}</ChildrenWrapper>
    </Root>
  );
};
